import {
  getApiV1ThreeLetterCodePartnerAdminsGroups,
  getGetApiV1ThreeLetterCodePartnerAdminsGroupsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsGroups200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  /** グループ一覧データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsGroups200;
};

/**
 * useGetGroupsフックの型定義
 */
type IUseGetGroups = (args: Args) => ReturnType;

/**
 * 利用企業編集フォーム用グループ一覧取得フック
 */
export const useGetGroups: IUseGetGroups = ({ threeLetterCode }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsGroupsKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsGroups(threeLetterCode),
    { suspense: true }
  );

  return {
    data,
  };
};
